spineSymbolAnimator = {};
spineSymbolAnimator.useBackings = false; // Set to true to enable backing sprites
spineSymbolAnimator.animationPool = [
  {
    poolName: 'Empty',
    number: 0,
    pool: [],
    anims: [],
    backings: [],
  },
];
spineSymbolAnimator.currentAnimations = [];
spineSymbolAnimator.gameReels = undefined;
spineSymbolAnimator.slotContainer = undefined;
spineSymbolAnimator.ready = false;
spineSymbolAnimator.callBackDelay = 0;
spineSymbolAnimator.backings = [];

spineSymbolAnimator.symbolIDMap = [
  { id: 0, name: 'Ten', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 },
  { id: 1, name: 'Jack', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 1 },
  { id: 2, name: 'Queen', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 1 },
  { id: 3, name: 'King', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 1 },
  { id: 4, name: 'Ace', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 1 },
  { id: 5, name: 'Cake', anim: 0, scaleX: 0.25, scaleY: 0.25, offsetX: 2.5, offsetY: 22 },
  { id: 6, name: 'Hogtail', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 },
  { id: 7, name: 'DiscoBall', anim: 0, scaleX: 0.33, scaleY: 0.33, offsetX: 0, offsetY: 0 },
  { id: 8, name: 'Dancer', anim: 0, scaleX: 0.064, scaleY: 0.063, offsetX: 0, offsetY: -15 },
  { id: 9, name: 'Logo', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 },
  { id: 10, name: 'Wild', anim: 0, scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 },
];

spineSymbolAnimator.initialise = function () {
  spineSymbolAnimator.gameReels = gameData.reels;
  spineSymbolAnimator.slotContainer = resourceManager.get('mainReelsContainer:slotContainer:reelContainer');
  spineSymbolAnimator.backingContainer = resourceManager.get(
    'mainReelsContainer:slotContainer:reelContainer:backingContainer'
  );

  spineSymbolAnimator.createAnim('Ten', 0, ['10_Win']);
  spineSymbolAnimator.createAnim('Jack', 0, ['10_Win']); // Note this is correct. The spine anim is named incorrectly
  spineSymbolAnimator.createAnim('Queen', 0, ['Q_Win']);
  spineSymbolAnimator.createAnim('King', 0, ['K_Win']);
  spineSymbolAnimator.createAnim('Ace', 0, ['Win_Anim']);
  spineSymbolAnimator.createAnim('Cake', 0, ['Cake_Win']);
  spineSymbolAnimator.createAnim('Hogtail', 0, ['Pigtini_Win']);
  spineSymbolAnimator.createAnim('DiscoBall', 0, ['Discoball_Win_Anim']);
  spineSymbolAnimator.createAnim('Dancer', 0, ['Dancer_Win']);
  spineSymbolAnimator.createAnim('Logo', 0, ['animation']);
  spineSymbolAnimator.createAnim('Wild', 0, ['Wild_Win']);

  spineSymbolAnimator.ready = true;
};

spineSymbolAnimator.createAnim = function (name, index, animNames = undefined) {
  let spineAnim = undefined;
  let backings = [];
  let symbolId;
  for (let index = 0; index < spineSymbolAnimator.symbolIDMap.length; index++) {
    if (spineSymbolAnimator.symbolIDMap[index].name === name) {
      symbolId = spineSymbolAnimator.symbolIDMap[index].id;
      break;
    }
  }

  let animNamesCheck = animNames;

  let found = false;

  const symbolMapData = spineSymbolAnimator.symbolIDMap.find((sym) => sym.id === symbolId);
  const scaleX = symbolMapData?.scaleX || 1;
  const scaleY = symbolMapData?.scaleY || 1;

  //Search for pool name
  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    //If pool name exists add a new anim there
    if (poolType.poolName === name) {
      found = true;

      animNamesCheck = poolType.anims;

      // Safety check in case pool anims are undefined
      if (!animNamesCheck || animNamesCheck.length === 0) {
        return;
      }

      spineAnim = resourceManager.createObject(
        'spine',
        'SpineSymScale' + name + index,
        spineSymbolAnimator.slotContainer,
        {
          name: name,
          defaultAnimation: animNamesCheck[0],
          scaleX: scaleX,
          scaleY: scaleY,
        }
      );

      //create backings
      if (spineSymbolAnimator.useBackings) {
        for (let i = 0; i < poolType.backingPool.fileNames.length; i++) {
          const backingFileName = poolType.backingPool.fileNames[i];

          const backing = resourceManager.createObject(
            'sprite',
            name + index + 'SpineSymBacking' + i,
            spineSymbolAnimator.backingContainer,
            {
              fileName: backingFileName,
              scale: 0.5,
              anchor: 0.5,
            }
          );
          backing.visible = false;
          backings.push(backing);
        }
      }

      poolType.pool.push(spineAnim);
      poolType.number++;
      poolType.backingPool.pool.push([backings]);

      break;
    }
  }

  if (!found) {
    // Safety check for symbols without animations (like Logo)
    // This only applies when creating a NEW pool, not when reusing existing pools
    if (!animNamesCheck || animNamesCheck.length === 0) {
      return;
    }

    //Otherwise create a new anim pool with this name
    spineAnim = resourceManager.createObject(
      'spine',
      'SpineSymScale' + name + index,
      spineSymbolAnimator.slotContainer,
      {
        name: name,
        defaultAnimation: animNamesCheck[0],
        scaleX: scaleX,
        scaleY: scaleY,
      }
    );

    //create backings
    const fileNames = [];

    if (spineSymbolAnimator.useBackings) {
      for (let i = 0; i < animNamesCheck.length; i++) {
        const symbolIdOffset = i * 20;
        const backingFileName = spineSymbolAnimator.getSymbolBackingFileName(symbolId + symbolIdOffset);

        const backing = resourceManager.createObject(
          'sprite',
          name + index + 'SpineSymBacking' + i,
          spineSymbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 0.5,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
        fileNames.push(backingFileName);
      }
    }

    spineSymbolAnimator.animationPool.push({
      poolName: name,
      number: 0,
      pool: [spineAnim],
      anims: animNamesCheck,
      backingPool: {
        pool: [backings],
        fileNames: fileNames,
      },
    });
  }

  spineAnim.visible = false;

  return { spine: spineAnim, backings: backings };
};

spineSymbolAnimator.findSpineAndBacking = function (symbolId) {
  let spine = undefined;
  let location = 0;
  let number = 0;
  symbolId = symbolId % 20;
  let spineAnimName = spineSymbolAnimator.symbolIDMap[symbolId].name;

  if (spineAnimName === 'Empty') {
    return undefined;
  }

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        spine = poolType.pool[0];
        let backings = poolType.backingPool && poolType.backingPool.pool ? poolType.backingPool.pool[0] : [];

        poolType.pool.splice(0, 1);
        if (poolType.backingPool && poolType.backingPool.pool) {
          poolType.backingPool.pool.splice(0, 1);
        }
        return { spine: spine, backings: backings };
      }
    }
  }

  let spineAndbackings = spineSymbolAnimator.createAnim(spineAnimName, number + 1);
  spineSymbolAnimator.animationPool[location].pool.pop();
  if (spineSymbolAnimator.animationPool[location].backingPool) {
    spineSymbolAnimator.animationPool[location].backingPool.pool.pop();
  }

  return spineAndbackings;
};

spineSymbolAnimator.animate = function (symbols, callback, callBackDelay) {
  spineSymbolAnimator.finishedCallback = callback;
  spineSymbolAnimator.callBackDelay = callBackDelay;

  const animating = [];
  for (let i = 0; i < symbols.length; i++) {
    let symbol = symbols[i];
    animating[i] = spineSymbolAnimator.animateSymbol(symbol);
  }
  const noneAnimating = animating.every((val) => val === false);
  if (noneAnimating === true) {
    // no symbol has animated -
    spineSymbolAnimator.callBackDelay = 1000;
    spineSymbolAnimator.handleFinishedCallback();
  }
};

spineSymbolAnimator.animateSymbol = function (symbol) {
  const id = symbol.symbolId % 20;
  let sizeOffset = Math.floor(symbol.symbolId / 20);
  const reel = symbol.cell.reel;
  const row = symbol.cell.row;

  let symbolMapIndex = undefined;

  for (let index = 0; index < spineSymbolAnimator.symbolIDMap.length; index++) {
    if (spineSymbolAnimator.symbolIDMap[index].id === id) {
      symbolMapIndex = index;
      break;
    }
  }

  let spineAndBacking = spineSymbolAnimator.findSpineAndBacking(symbolMapIndex);

  if (spineAndBacking === undefined) {
    return false;
  }

  let animNum =
    spineSymbolAnimator.symbolIDMap[symbolMapIndex].anim === 0 && sizeOffset > 0
      ? 1 * sizeOffset
      : spineSymbolAnimator.symbolIDMap[symbolMapIndex].anim * sizeOffset;
  let animNames = spineSymbolAnimator.findAnimNames(symbolMapIndex);

  let symbolToHide = resourceManager.get(
    'mainReelsContainer:slotContainer:reelContainer:reel' + reel + ':symbol' + row
  );
  symbolToHide.visible = false;
  const spine = spineAndBacking.spine;
  const backing = spineSymbolAnimator.useBackings ? spineAndBacking.backings[animNum] : null;

  if (backing) {
    backing.visible = true;
  }

  let animationObject = {
    anim: spine,
    reel: reel,
    row: row,
    backing: backing,
    symbolToHide: symbolToHide,
    symbolId: symbol.symbolId,
  };

  spineSymbolAnimator.currentAnimations.push(animationObject);

  // Set anchor after creation for spine objects
  if (spine.anchor) {
    spine.anchor.set(0.5, 0.5);
  }

  spineSymbolAnimator.positionAnim(animationObject);

  spine.visible = true;
  spine.anim = animNames[animNum];
  spine.play(animNames[animNum], false, 0, () => {
    spineSymbolAnimator.animationFinished(animationObject);
    spineSymbolAnimator.returnToPool(
      spineSymbolAnimator.symbolIDMap[symbolMapIndex].name,
      spine,
      spineAndBacking.backings
    );
    symbolToHide.visible = true;
  });

  return true;
};

spineSymbolAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.visible = false;
    if (animationObject.backing) {
      animationObject.backing.visible = false;
    }
    animationObject.symbolToHide.visible = true;
    spineSymbolAnimator.currentAnimations.splice(spineSymbolAnimator.currentAnimations.indexOf(animationObject), 1);
  }

  if (spineSymbolAnimator.currentAnimations.length === 0) {
    spineSymbolAnimator.handleFinishedCallback();
  }
};

spineSymbolAnimator.handleFinishedCallback = function () {
  if (spineSymbolAnimator.finishedCallback) {
    if (spineSymbolAnimator.callBackDelay !== undefined) {
      spineSymbolAnimator.completeCallback = spineSymbolAnimator.finishedCallback;
      timerManager.addTimeout(spineSymbolAnimator.callBackDelay, function () {
        if (spineSymbolAnimator.completeCallback) {
          spineSymbolAnimator.completeCallback();
        }
      });
    } else {
      spineSymbolAnimator.finishedCallback();
    }
  }
};

spineSymbolAnimator.findAnimNames = function (symbolId) {
  let spineAnimName = spineSymbolAnimator.symbolIDMap[symbolId].name;

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      animNames = poolType.anims;
      return animNames;
    }
  }

  return undefined;
};

spineSymbolAnimator.returnToPool = function (name, spine, backings) {
  if (spineSymbolAnimator.useBackings && backings) {
    for (let index = 0; index < backings.length; index++) {
      const backing = backings[index];
      backing.visible = false;
    }
  }

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(spine);
      if (spineSymbolAnimator.useBackings) {
        poolType.backingPool.pool.push(backings);
      }
    }
  }
};

spineSymbolAnimator.positionAnim = function (animationObject, symbol = undefined) {
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  if (symbol === undefined) {
    symbol = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + reel + ':symbol' + row);
  }

  const symbolPos = helper.getCenterSymbolsPos(reel, row);

  // Get the symbol ID from the animation object or spine name
  let symbolId = 0; // Default to Ten symbol
  if (animationObject.symbolId !== undefined) {
    symbolId = animationObject.symbolId % 20;
  } else {
    // Try to find it from the spine name
    const spineName = anim.name;
    const symbolMapData = spineSymbolAnimator.symbolIDMap.find((sym) => spineName.includes(sym.name));
    if (symbolMapData) {
      symbolId = symbolMapData.id;
    }
  }

  // Find the symbol data to get offsets
  const symbolMapData = spineSymbolAnimator.symbolIDMap.find((sym) => sym.id === symbolId);
  const offsetX = symbolMapData?.offsetX || 0;
  const offsetY = symbolMapData?.offsetY || 0;

  const x = symbolPos.x + offsetX;
  const y = symbolPos.y + offsetY;

  anim.position.set(x, y);
  if (animationObject.backing) {
    animationObject.backing.position.set(x, y);
  }
};

spineSymbolAnimator.getSymbolBackingFileName = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  let symbolType = 'Default';

  let fileName;
  switch (sizeOffset) {
    case 0:
      switch (symbolType) {
        case 'Default':
          fileName = 'Symbols/BACK_BORDER_x3.png';
          break;
      }
      break;
  }

  return fileName;
};

spineSymbolAnimator.getSpineAnimation = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  switch (sizeOffset) {
    case 0:
      switch (id) {
        case 0:
          return '10_Win';
        case 1:
          return '10_Win';
        case 2:
          return 'Q_Win';
        case 3:
          return 'K_Win';
        case 4:
          return 'Win_Anim';
        case 5:
          return 'Cake_Win';
        case 6:
          return 'Pigtini_Win';
        case 7:
          return 'Discoball_Win_Anim';
        case 8:
          return 'Dancer_Win';
        case 9:
          return 'animation';
        case 10:
          return 'Wild_Win';
      }
      break;
  }

  return 'Failed to find spine animation.. Somehow????';
};

spineSymbolAnimator.getSpineName = function (symbolId) {
  const id = symbolId % 20;
  switch (id) {
    case 0:
      return 'Ten';
    case 1:
      return 'Jack';
    case 2:
      return 'Queen';
    case 3:
      return 'King';
    case 4:
      return 'Ace';
    case 5:
      return 'Cake';
    case 6:
      return 'Hogtail';
    case 7:
      return 'DiscoBall';
    case 8:
      return 'Dancer';
    case 9:
      return 'Logo';
    case 10:
      return 'Wild';
  }
};

spineSymbolAnimator.skip = function (callCallback = false) {
  spineSymbolAnimator.currentAnimations.forEach((animation) => {
    spineSymbolAnimator.returnToPool(animation.anim.name, animation.anim, animation.backing);
    animation.anim.visible = false;
    animation.symbolToHide.visible = true;
    if (spineSymbolAnimator.useBackings && animation.backing) {
      spineSymbolAnimator.backings.splice(spineSymbolAnimator.currentAnimations.indexOf(animation.backing), 1);
      resourceManager.destroyObject(animation.backing.name);
    }
  });

  spineSymbolAnimator.currentAnimations = [];
  if (callCallback && spineSymbolAnimator.finishedCallback) {
    spineSymbolAnimator.finishedCallback();
  }
  spineSymbolAnimator.finishedCallback = undefined;
};

spineSymbolAnimator.orientationChange = function () {
  if (spineSymbolAnimator.ready) {
    timerManager.addTimer(5, () => {
      spineSymbolAnimator.currentAnimations.forEach((animationObject) => {
        spineSymbolAnimator.positionAnim(animationObject);
      });
    });
  }
};

Reflex.registerEventHandler('layoutChange', spineSymbolAnimator.orientationChange);
